<template>
	<div>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Upgrade Your Account Limit</h2>
			</div>
		</div>

		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">

					<div class="row">

						<div class="col-lg-8">

							<form @submit.prevent="onSubmit" autocomplete="off">

								<div class="form-card">

									<div class="form-card-header">
										<h3>Limit Upgrade Request</h3>
									</div>

									<div class="form-card-forms">

										<!-- REQUEST -->
										<div class="row">

											<div class="col-lg-6">
												<label>Request Amount *</label>

												<input type="number"
													   class="form-control"
													   v-model="vModel.RequestAmount" />
											</div>

											<div class="col-lg-6">

												<label>Limit Reason *</label>

												<kendo-dropdownlist v-if="CustomizeTransactionPurposeOptions.length"
																	name="LimitReason"
																	class="form-control"
																	v-model.number="vModel.LimitReason"
																	:data-text-field="'Text'"
																	:data-value-field="'Id'"
																	:option-label="'Select Reason'"
																	:data-source="CustomizeTransactionPurposeOptions"
																	:data-value-primitive="true"
																	:filter="'startswith'"
																	ref="optionlist"
																	@change="onLimitReasonChange" />
											</div>

										</div>

										<!-- IF OTHERS -->
										<div class="row mt-2" v-if="showOtherReason">

											<div class="col-lg-12">
												<label>Other Reason *</label>

												<input type="text"
													   class="form-control"
													   v-model="vModel.LimitReasonOtherText" />
											</div>

										</div>

										<!-- DATE -->
										<div class="row mt-3">

											<div class="col-lg-6">
												<label>Start Date *</label>

												<kendo-datepicker class="form-control"
																  v-model="vModel.StartDate"
																  :format="'dd/MM/yyyy'"
																  :min="today"
																  @change="validateDates" />
											</div>

											<div class="col-lg-6">
												<label>End Date *</label>

												<kendo-datepicker class="form-control"
																  v-model="vModel.EndDate"
																  :format="'dd/MM/yyyy'"
																  :min="today"
																  @change="validateDates" />

												<div class="text-danger" v-if="dateError">
													{{ dateError }}
												</div>
											</div>

										</div>

										<hr />

										<h5>Add Document</h5>

										<div class="row">

											<div class="col-lg-6">
												<label>Document Ref No *</label>

												<input type="text"
													   class="form-control"
													   v-model="tempDocument.refNo" />

												<div class="text-danger" v-if="errors.refNo">
													{{ errors.refNo }}
												</div>
											</div>

											<div class="col-lg-6">
												<label>Select File *</label>

												<input type="file"
													   class="form-control"
													   ref="fileInput"
													   @change="onFileSelect" />

												<div class="text-danger" v-if="errors.file">
													{{ errors.file }}
												</div>
											</div>

										</div>

										<br />

										<button type="button"
												class="btn btn-primary"
												@click="addDocument">
											Add Document
										</button>

										<hr />

										<h5>Added Documents</h5>

										<div v-if="!vModel.SupportingDocuments.length">
											No documents added
										</div>

										<div v-for="(doc, index) in vModel.SupportingDocuments"
											 :key="index"
											 class="border p-2 mb-2">

											<strong>Ref:</strong> {{ doc.refNo }}

											<div v-if="doc.previewType && doc.previewType.includes('image')">
												<img :src="doc.preview"
													 style="width:120px;height:120px" />
											</div>

											<div v-else>
												📄 File Uploaded
											</div>

											<br />

											<button type="button"
													class="btn btn-danger btn-sm"
													@click="deleteDocument(index)">
												Delete
											</button>

										</div>

									</div>

								</div>

								<!-- SUBMIT -->
								<div class="submit-option">

									<button class="btn btn-success"
											type="submit"
											:disabled="isProcessing">

										{{ isProcessing ? 'Submitting...' : 'Submit Request' }}

									</button>

								</div>

							</form>

						</div>

					</div>

				</div>

			</div>
		</div>

	</div>
</template>

<script>
	import ListService from "../../services/list";
	import commonService from "../../services/common";
	export default {
		name: "LimitUpgradeRequest",

		data() {
			return {
				CustomizeTransactionPurposeOptions: [],
				maxDate: new Date(),
				today: new Date(),
				dateError: "",
				isProcessing: false,

				showOtherReason: false,

				vModel: {
					RequestAmount: null,
					LimitReason: null,
					LimitReasonText: "",
					LimitReasonOtherText: "",
					StartDate: null,
					EndDate: null,
					SupportingDocuments: []
				},

				tempDocument: {
					refNo: "",
					file: null,
					fileName: "",
					type: "",
					fileKey: "",
					preview: "",
					previewType: ""
				},

				errors: {
					refNo: "",
					file: ""
				}
			};
		},

		created() {
			ListService.get("list/CustomizeTransactionPurposeOptions")
				.then(res => {
					this.CustomizeTransactionPurposeOptions = res.body || [];
				});
		},

		methods: {

			onLimitReasonChange(e) {
				this.showOtherReason = false;
				const selected = this.CustomizeTransactionPurposeOptions
					.find(x => x.Id === this.vModel.LimitReason);

				this.vModel.LimitReasonText = selected ? selected.Text : "";

				var dropDownList = this.$refs.optionlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				this.vModel.LimitReason = selectedVlaue;
				// 6 = Others
				//this.showOtherReason = (this.vModel.LimitReason === 6);

				if (this.vModel.LimitReason == 6) {
					this.showOtherReason = true;
				}

				if (!this.showOtherReason) {
					this.vModel.LimitReasonOtherText = "";
				}
			},

			validateDates() {

				this.dateError = "";

				if (!this.vModel.StartDate || !this.vModel.EndDate)
					return;

				if (new Date(this.vModel.EndDate) < new Date(this.vModel.StartDate)) {
					this.dateError = "End Date cannot be earlier than Start Date";
					this.vModel.EndDate = null;
				}
			},

			onFileSelect(event) {

				const file = event.target.files[0];
				if (!file) return;

				const fileKey = `${file.name}_${file.size}_${file.type}`;

				this.tempDocument.file = file;
				this.tempDocument.fileName = file.name;
				this.tempDocument.type = file.type;
				this.tempDocument.fileKey = fileKey;

				if (file.type.includes("image")) {
					const reader = new FileReader();
					reader.onload = e => {
						this.tempDocument.preview = e.target.result;
						this.tempDocument.previewType = file.type;
					};
					reader.readAsDataURL(file);
				}
			},

			addDocument() {

				this.errors = { refNo: "", file: "" };

				if (!this.tempDocument.refNo)
					this.errors.refNo = "Reference required";

				if (!this.tempDocument.file)
					this.errors.file = "File required";

				if (this.errors.refNo || this.errors.file) return;

				this.vModel.SupportingDocuments.push({ ...this.tempDocument });

				this.tempDocument = {
					refNo: "",
					file: null,
					fileName: "",
					type: "",
					fileKey: "",
					preview: "",
					previewType: ""
				};

				this.$refs.fileInput.value = "";
			},

			deleteDocument(index) {
				this.vModel.SupportingDocuments.splice(index, 1);
			},

			onSubmit() {

				if (this.isProcessing) return;

				if (!this.vModel.RequestAmount ||
					!this.vModel.LimitReason ||
					!this.vModel.StartDate ||
					!this.vModel.EndDate) {
					this.$toastr("error", "Fill all required fields");
					return;
				}

				if (this.showOtherReason && !this.vModel.LimitReasonOtherText) {
					this.$toastr("error", "Please enter other reason");
					return;
				}
				if (!this.vModel.SupportingDocuments ||
					this.vModel.SupportingDocuments.length === 0) {
					this.$toastr("error", "Please add at least one supporting document");
					return;
				}
				this.isProcessing = true;

				const documents = this.vModel.SupportingDocuments.map(d => ({
					refNo: d.refNo,
					fileName: d.fileName,
					fileType: d.type,
					fileContent: d.preview?.split(",")[1] || ""
				}));

				this.$http.post("customizetransactionlimit/save", {
					amount: this.vModel.RequestAmount,
					limitReason: this.vModel.LimitReason,
					limitReasonText: this.vModel.LimitReasonText,
					limitReasonOtherText: this.vModel.LimitReasonOtherText,
					startDate: commonService.ToYYYYMMDD(
						this.vModel.StartDate
					),
					endDate: commonService.ToYYYYMMDD(this.vModel.EndDate),
					supportingDocuments: documents
				})
					.then(() => {
						this.$toastr("success", "Submitted successfully");
						this.$router.push("/dashboard");
					})
					.finally(() => {
						this.isProcessing = false;
					});
			}
		}
	};
</script>
